<template>
  <div class="label-radio-align" :class="module['label-radio-align']">
    <div :class="[module.label, module['setting-label']]">翻转</div>
    <div
      class="ant-radio-group ant-radio-group-outline ant-radio-group-default"
    >
      <el-tooltip content="水平翻转" :disabled="disabled" :enterable="false">
        <div
          @click="onChange('horizontal')"
          class="ant-radio-button-wrapper"
          :class="{
            'ant-radio-button-wrapper-checked': chooseList.indexOf('horizontal')>-1,
            'ant-radio-button-wrapper-disabled': disabled
          }"
        >
          <a-icon :component="FlipIcon" />
        </div>
      </el-tooltip>
      <el-tooltip content="竖直翻转" :disabled="disabled" :enterable="false">
        <div
          @click="onChange('vertical')"
          class="ant-radio-button-wrapper"
          :class="{
            'ant-radio-button-wrapper-checked':  chooseList.indexOf('vertical')>-1,
            'ant-radio-button-wrapper-disabled': disabled
          }"
        >
          <a-icon :component="VerticalFlipIcon" />
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import module from './LabelRadioAlign.vue?vue&type=style&index=0&module=true&lang=css';
import './LabelRadioAlign.vue?vue&type=style&index=1&lang=css';

const FlipIcon = {
  render() {
    return this.$createElement('svg',
      { attrs: { viewBox: '0 0 1024 1024' } },
      [
        this.$createElement('path', {
          attrs: { d: 'M554.666667 810.666667v85.333333h-85.333334v-85.333333h85.333334z m380.032-565.717334a21.333333 21.333333 0 0 1 3.968 12.373334v509.610666a21.333333 21.333333 0 0 1-33.706667 17.365334l-356.693333-254.805334a21.333333 21.333333 0 0 1 0-34.730666l356.693333-254.762667a21.333333 21.333333 0 0 1 29.738667 4.949333zM89.301333 244.821333a21.333333 21.333333 0 0 1 29.781334-4.949333l356.693333 254.762667a21.333333 21.333333 0 0 1 0 34.730666l-356.693333 254.762667A21.333333 21.333333 0 0 1 85.333333 766.805333V257.194667a21.333333 21.333333 0 0 1 3.968-12.373334zM554.666667 640v85.333333h-85.333334v-85.333333h85.333334zM170.666667 381.568v260.821333l182.570666-130.432L170.666667 381.568zM554.666667 298.666667v85.333333h-85.333334V298.666667h85.333334z m0-170.666667v85.333333h-85.333334V128h85.333334z' }
        })
      ]);
  }
};

const VerticalFlipIcon = {
  render() {
    return this.$createElement('svg',
      { attrs: { viewBox: '0 0 1024 1024' } },
      [
        this.$createElement('path', {
          attrs: { d: 'M213.333333 554.666667H128v-85.333334h85.333333v85.333334z m565.76 380.032a21.333333 21.333333 0 0 1-12.416 3.968H257.066667a21.333333 21.333333 0 0 1-17.322667-33.706667l254.762667-356.693333a21.333333 21.333333 0 0 1 34.730666 0l254.805334 356.693333a21.333333 21.333333 0 0 1-4.992 29.738667z m0.085334-845.397334a21.333333 21.333333 0 0 1 6.912 26.453334l-1.92 3.285333-254.805334 356.693333a21.333333 21.333333 0 0 1-32.213333 2.986667l-2.517333-2.986667-254.762667-356.693333a21.333333 21.333333 0 0 1 13.525333-33.365333L257.237333 85.333333h509.568a21.333333 21.333333 0 0 1 12.373334 3.968zM384 554.666667H298.666667v-85.333334h85.333333v85.333334z m258.432-384H381.610667l130.432 182.570666 130.389333-182.613333zM725.333333 554.666667h-85.333333v-85.333334h85.333333v85.333334z m170.666667 0h-85.333333v-85.333334h85.333333v85.333334z' }
        })
      ]);
  }
};

export default {
  props: ['label', 'value', 'disabled'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return { module, FlipIcon, VerticalFlipIcon,chooseList:[] };
  },
  methods: {
    onChange: function (value) {
      if (this.disabled) {
        return;
      }
      if(this.chooseList.indexOf(value)>-1){
        this.chooseList.splice(this.chooseList.indexOf(value),1)
      }else{
        this.chooseList.push(value);
      }
      if(this.chooseList.length>0){
        var chooseList = this.chooseList.join(',');
        this.$emit('change', chooseList);
      }else{
        this.$emit('change', 'none');
      }
    }
  }
}
</script>